"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamIdsSchema = exports.updateTeamRequestSchema = exports.createTeamRequestSchema = exports.teamMembershipSchema = exports.teamSchema = exports.teamRefSchema = void 0;
const zod_1 = require("zod");
const identifier_1 = require("../identifier");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ R-60 · Teams — a list the workspace keeps, and a person can be in several. │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **A GROUPING, NOT A PERMISSION — R-13 STANDS.** Nothing reads a team to decide what somebody
 * may see. It is a label people are listed under and a filter every people-ish screen offers.
 */
/** A team as a person carries it, and as a filter offers it. */
exports.teamRefSchema = zod_1.z.object({
    id: zod_1.z.string(),
    /** `team_9d3b6e4a` — minted by `0241`; see `identifier.ts`. */
    identifier: (0, identifier_1.identifierSchema)('team'),
    name: zod_1.z.string(),
});
exports.teamSchema = exports.teamRefSchema.extend({
    /**
     * How many people are in it.
     *
     * ⚠️ **The delete confirm states this before it asks** — deleting a team takes it off every one
     * of them (`0241` cascades), and *"6 people are in this team"* is the thing somebody agrees to.
     */
    memberCount: zod_1.z.number().int().nonnegative(),
    version: zod_1.z.number().int().positive(),
});
/**
 * Who is in which team — what a list that filters on the client (a project's people, a settings
 * grid) needs to apply the *Csapat* filter. Read on the same actions as the team list itself.
 */
exports.teamMembershipSchema = zod_1.z.object({
    memberId: zod_1.z.string(),
    teamIds: zod_1.z.array(zod_1.z.string()),
});
exports.createTeamRequestSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(1).max(80),
});
exports.updateTeamRequestSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(1).max(80),
    version: zod_1.z.number().int().positive(),
});
/**
 * ⚠️ **A person's teams are written as the whole set**, the way the person page's multi-select holds
 * them. A cap far above any real team count, so a request cannot ask the server to insert thousands.
 */
exports.teamIdsSchema = zod_1.z.array(zod_1.z.uuid()).max(50);
//# sourceMappingURL=teams.js.map